module.exports = __webpack_public_path__ + "img/academico-training.156cc0bf.svg";